import ModalComponent from "../../biblio/Modal/ModalComponent";
import PrimaryButton from "../../biblio/Buttons/PrimaryButton";
import { Col, Form, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../apis/store";
import {
  toPrintDeclaration,
  toRegenerateOtp,
  toVerifyOtp,
} from "../../apis/actions/recipient.actions";
import { InputOTP } from "antd-input-otp";
import { useEffect, useState } from "react";
import { PrinterOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { showNotitfication } from "../utils/utils";
import { useCookies } from "react-cookie";
import modalOtpAnimation from "../../assets/animations/otp-modal.json";
import Lottie from "lottie-react";
import { setOtpId } from "../../apis/slices/recipientSlice";

interface OtpModalProps {
  onClose: () => void;
  open?: boolean;
  recordId?: number;
  model: "beneficiary" | "sponsor" | "login";
  mobile: string;
  email?: string;
  whatsapp?: string;
}

const OtpModal = ({
  open,
  onClose,
  recordId,
  model,
  mobile,
  email,
  whatsapp,
}: OtpModalProps) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [isClickable, setIsClickable] = useState<boolean>(false);

  const { loading } = useSelector((state: RootState) => state.recipient);
  const [, setCookie] = useCookies(["apiKey", "role"]);
  /* verify otp handler */
  const handleVerifyOtp = async (
    model: "beneficiary" | "sponsor" | "login"
  ) => {
    const otp = form.getFieldValue("otp");
    if (
      !otp ||
      otp.length !== 4 ||
      !otp ||
      otp.includes(undefined) ||
      otp.includes("")
    )
      return form.setFields([
        {
          name: "otp",
          errors: ["الرجاء إدخال رمز التحقق"],
        },
      ]);
    else {
      const success = (await dispatch(
        toVerifyOtp({
          otp: `${otp[0]}${otp[1]}${otp[2]}${otp[3]}`,
          request_id: recordId,
          model,
          mobile,
          email,
          whatsapp,
        })
      )) as any;
      const verifyOtp = success?.payload?.data?.result;
      if (verifyOtp?.id ){
      dispatch(setOtpId(verifyOtp?.id));
      }
      if (verifyOtp?.code === 200) {
        form.resetFields();
        if (model === "login") {
          setCookie("apiKey", Object.values(verifyOtp)[0]);
          setCookie("role", Object.values(verifyOtp)[1]);
          navigate("/profile");
        } else if (model === "sponsor") {
          showNotitfication(verifyOtp?.message, "success");
          setTimeout(() => {
            navigate("/");
          }, 3000);
        } else {
          showNotitfication(verifyOtp?.message, "success");
        }
        onClose();
        setTimeout(() => {
          setIsModalVisible(true);
        }, 3000);
      } else {
        showNotitfication(verifyOtp?.message, "error");
      }
    }
  };

  /* regenerate otp handler */
  const handleRegenerateOtp = async () => {
    if (!isClickable) return;
    const success = (await dispatch(
      toRegenerateOtp({
        id: recordId,
        res_model:
          model === "beneficiary"
            ? "association.beneficiary.request"
            : "association.sponsorship.request",
        mobile: mobile,
        whatsapp,
      })
    )) as any;

    const regenrateOtp = success?.payload?.data?.result;
    if (regenrateOtp?.code === 200) {
      showNotitfication(regenrateOtp?.message, "success");
    } else {
      showNotitfication(regenrateOtp?.message, "error");
    }
    // Reset clickable state for another 2-minute delay
    setIsClickable(false);
    setTimeout(() => setIsClickable(true), 120000);
  };

  useEffect(() => {
    setIsClickable(false);
    const timer = setTimeout(() => setIsClickable(true), 120000);

    return () => clearTimeout(timer);
  }, []);

  const handlePrint = async () => {
    (await dispatch(toPrintDeclaration(recordId))) as any;
  };

  return (
    <>
      <ModalComponent
        width={500}
        title=""
        open={open}
        onClose={onClose}
        closeOnOutsideClick={true}
      >
        <div className="takaful--otp-modal-content">
          <div className="takaful--otp-modal-image-text">
            <Lottie
              style={{ width: "60%" }}
              animationData={modalOtpAnimation}
              loop={true}
            />
            <h3>رمز التحقق</h3>
            <span>
              {whatsapp
                ? "لقد أرسلنا لك رمزاً على الواتساب"
                : "لقد أرسلنا لك رمزاً على جوالك"}
            </span>
          </div>

          <div className="takaful--otp-modal-input">
            <Form form={form}>
              <Row>
                <Col span={2}></Col>
                <Col span={20}>
                  <Form.Item
                    name="otp"
                    rules={[
                      { required: true, message: "الرجاء إدخال رمز التحقق" },
                    ]}
                  >
                    <InputOTP autoFocus inputMode="tel" length={4} />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>

          <div className="takaful--otp-modal-footer">
            <span className="takaful--otp-modal-text-footer">
              <button
                onClick={handleRegenerateOtp}
                disabled={!isClickable}
                className={`takaful--regenerate-otp-btn ${
                  isClickable ? "clickable" : "disabled"
                }`}
              >
                إعادة المحاولة
              </button>
              لم أستلم الرمز ؟
            </span>
            <div>
              <PrimaryButton
                title="تحقق"
                onClick={() => handleVerifyOtp(model)}
                disabled={loading}
              />
            </div>
          </div>
        </div>
      </ModalComponent>

      {model === "beneficiary" && (
        <ModalComponent
          title=""
          open={isModalVisible}
          closeOnOutsideClick={true}
          onClose={() => setIsModalVisible(false)}
          width={500}
          showCloseIcon={false}
        >
          <div className="takaful--declaration-modal-content">
            <p>تم تسجيل الطلب بنجاح</p>
            <p>يمكنكم طباعة الإفادة بتسجيل في الجمعية</p>
            <div className="takaful--declaration-modal-footer">
              <PrimaryButton
                title="إغلاق"
                onClick={() => {
                  setIsModalVisible(false);
                  navigate("/");
                }}
              />
              <PrimaryButton
                title="طباعة الإفادة"
                icon={<PrinterOutlined />}
                onClick={handlePrint}
                disabled={loading}
                className="takaful--print-btn-container"
              />
            </div>
          </div>
        </ModalComponent>
      )}
    </>
  );
};

export default OtpModal;
